module.exports = require("./ccp.d.ts");